import React from 'react';

export type MountAfterDelayOwnProps = {
    delay: number;
    children: React.ReactNode;
    fallback?: React.ReactNode;
};

export type MountAfterDelayProps = MountAfterDelayOwnProps;

const MountAfterDelay: React.FC<MountAfterDelayProps> = (props) => {
    const [isMounted, setIsMounted] = React.useState(false);
    React.useEffect(() => {
        const timeout = setTimeout(() => {
            setIsMounted(true);
        }, props.delay);
        return () => clearTimeout(timeout);
    }, [props.delay]);

    return isMounted ? <>{props.children}</> : props.fallback || null;
};

export default React.memo(MountAfterDelay);
